import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download-icon",
  "use": "icon-download-icon-usage",
  "viewBox": "0 0 24 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 22\" id=\"icon-download-icon\">\n  <path id=\"icon-download-icon_iconmonstr-upload-20\" d=\"M8,14.7H2V21H22V14.7H16v-2h8V23H0V12.7H8ZM7,7l5-6,5,6H13V18H11V7Z\" transform=\"translate(0 -1)\" fill=\"#3f45d1\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol